module.exports = __webpack_public_path__ + "img/icon_fans.f7634bcf.svg";